export const CHAT_EMOJI_TYPE = {
  LIKE: 'like',
}

export const CHAT_CHANNEL_KIND = {
  DIRECT: 'DIRECT',
  GROUP: 'GROUP',
  ROOM: 'ROOM',
}
